import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { fmt } from "@/lib/format";

export const DendaSelisih = ({ rows }) => {
  const [open, setOpen] = useState(false);
  if (!rows?.length) return null;
  const shown = open ? rows : rows.slice(0, 5);
  return (
    <div data-testid="denda-selisih-alert" className="rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200">
      <p className="flex items-center gap-2 font-semibold"><AlertTriangle className="h-4 w-4" />
        {rows.length} selisih: total sheet DENDA ≠ total DETAIL_DENDA (per unit per bulan)
      </p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-xs">
          <thead><tr className="text-left"><th className="py-1 pr-3">Bulan</th><th className="pr-3">Unit</th><th className="pr-3 text-right">DENDA</th><th className="pr-3 text-right">DETAIL_DENDA</th><th className="text-right">Selisih</th></tr></thead>
          <tbody>
            {shown.map((r) => (
              <tr key={`${r.unit}-${r.bulan_no}`} data-testid={`selisih-row-${r.unit}-${r.bulan_no}`} className="border-t border-amber-200 dark:border-amber-900">
                <td className="py-1 pr-3">{r.bulan}</td><td className="pr-3">{r.unit}</td>
                <td className="pr-3 text-right font-num">{fmt(r.denda, "rp")}</td><td className="pr-3 text-right font-num">{fmt(r.detail, "rp")}</td>
                <td className="text-right font-num font-semibold">{fmt(r.selisih, "rp")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length > 5 && (
        <button data-testid="denda-selisih-toggle" onClick={() => setOpen(!open)} className="mt-2 text-xs font-semibold underline">
          {open ? "Tampilkan lebih sedikit" : `Tampilkan semua (${rows.length})`}
        </button>
      )}
    </div>
  );
};
